<!-- src/components/NavBar.vue -->
<template>
  <header class="header">
    <div class="header-content">
      <div class="logo" @click="scrollToTop">
        <img
          :src="headerData.logo.imageUrl"
          :alt="$t('home.logoAlt')"
          class="logo-image"
        >
      </div>
      
      <!-- 导航菜单 -->
      <nav class="nav">
        <router-link
          v-for="(item, index) in headerData.navigation"
          :key="index"
          :to="getRoutePath(index)"
          class="nav-item"
          :class="{ active: item.active }"
          @mouseenter="item.hovered = true"
          @mouseleave="item.hovered = false"
          @click.native="setActiveNav(index)"
        >
          {{ $t(`nav.${item.key}`) }}
        </router-link>
      </nav>

      <!-- 语言切换组件 -->
      <div class="language" @click="toggleLanguage">
        <span>🌐</span>
        <span>{{ $t('nav.language') }}</span>
        <span class="dropdown-arrow" :class="{ rotated: languageDropdownOpen }">▼</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'CommonHeader',
  props: {
    headerData: {
      type: Object,
      default: () => ({
        logo: {
          title: 'PASTEUR',
          imageUrl: require('@/assets/image/logo.png')
        },
        navigation: [
          { key: 'welcome', active: true, hovered: false },
          { key: 'company', active: false, hovered: false },
          { key: 'products', active: false, hovered: false },
          { key: 'links', active: false, hovered: false }
        ]
      })
    }
  },
  data() {
    return {
      languageDropdownOpen: false
    }
  },
  methods: {
    // 获取路由路径
    getRoutePath(index) {
      const routes = ['/welcome', '/company', '/products', '/links'];
      return routes[index] || '/welcome';
    },

    // 处理服务协议链接点击
    goToTerms() {
      if (this.$route.path !== '/terms') {
        this.$router.push('/terms');
      }
    },

    // 导航激活状态切换
    setActiveNav(index) {
      this.headerData.navigation.forEach((item, i) => {
        item.active = i === index;
      });
      // 触发自定义事件通知父组件
      this.$emit('nav-change', index);
    },

    // 语言切换逻辑
    toggleLanguage() {
      const currentLocale = this.$i18n.locale;
      const newLocale = currentLocale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLocale;
      localStorage.setItem('language', newLocale);
      this.languageDropdownOpen = false;
    },

    // 返回顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
/* 头部导航样式 */
.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 0 40px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  border-bottom: 1px solid rgba(0, 212, 180, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  transition: all 0.3s ease;
  height: 80px;
  display: block !important;
  visibility: visible !important;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.logo {
  cursor: pointer;
  height: 36px; 
  width: auto;
  transition: transform 0.3s ease;
}

.logo-image {
  height: 55px; 
  width: auto;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-sub {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.nav {
  display: flex;
  gap: 40px;
}

.nav-item {
  color: #333;
  text-decoration: none;
  font-size: 13px;
  padding: 10px 0;
  border-bottom: 2px solid transparent;
  transition: all 0.3s ease;
  position: relative;
  display: inline-block;
}

.nav-item:hover,
.nav-item.active,
.nav-item.router-link-active {
  color: #00D4B4;
  border-bottom-color: #00D4B4;
}

.nav-item::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: #00D4B4;
  transition: width 0.3s ease;
}

.nav-item:hover::after,
.nav-item.router-link-active::after {
  width: 100%;
}

.language {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
  font-size: 14px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.language:hover {
  color: #00D4B4;
}
.dropdown-arrow {
  transition: transform 0.3s ease;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .header {
    padding: 0 20px;
    height: 60px;
  }
  
  .header-content {
    height: 60px;
  }
  
  .nav {
    gap: 20px;
  }
  
  .nav-item {
    font-size: 12px;
    padding: 8px 0;
  }
  
  .logo-image {
    height: 40px;
  }
  
  .language {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .header {
    padding: 0 15px;
  }
  
  .nav {
    gap: 15px;
  }
  
  .nav-item {
    font-size: 11px;
    padding: 6px 0;
  }
  
  .language span:not(.dropdown-arrow) {
    display: none;
  }
}
</style>